import React, { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { generateQrDataUrl } from "../utils/codeImages";

interface QrCodeImageProps {
  value: string;
  size?: number;
  className?: string;
}

export function QrCodeImage({ value, size = 100, className = "" }: QrCodeImageProps) {
  const [src, setSrc] = useState<string | null>(null);
  const [error, setError] = useState(false);
  const text = value?.trim() ?? "";

  useEffect(() => {
    if (!text) {
      setSrc(null);
      setError(true);
      return;
    }

    let cancelled = false;
    setError(false);
    setSrc(null);
    generateQrDataUrl(text, size * 2)
      .then((dataUrl) => {
        if (!cancelled) setSrc(dataUrl);
      })
      .catch(() => {
        if (!cancelled) setError(true);
      });
    return () => {
      cancelled = true;
    };
  }, [text, size]);

  if (error) {
    return (
      <div
        className={`bg-gray-50 rounded-lg border border-dashed border-gray-200 flex items-center justify-center text-[10px] text-gray-400 text-center px-2 ${className}`}
        style={{ width: size, height: size }}
      >
        {text ? "QR" : "Нет кода"}
      </div>
    );
  }

  if (!src) {
    return (
      <div
        className={`bg-gray-50 rounded-lg border border-gray-200 flex items-center justify-center ${className}`}
        style={{ width: size, height: size }}
      >
        <Loader2 size={20} className="animate-spin text-gray-300" />
      </div>
    );
  }

  return (
    <img
      src={src}
      alt="QR-код"
      width={size}
      height={size}
      className={`rounded-lg border border-gray-200 bg-white p-1 ${className}`}
    />
  );
}
